import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  getCategoryIsEarlyAccess,
  getCategoryDetails,
  getIsEarlyAccessCategoryComingSoon
} from "../../state/modules/category";
import { getViewportCategory } from "../../state/modules/layout/selectors";
import {
  getCategoryDetailsFeaturedHeaderData,
  getCategoryDetailsFeaturedHeaderEnabled,
  getCategorySeoLinks,
  getCategoryVisualCategories
} from "../../state/modules/category/selectors";

import CategoryHeader from "./CategoryHeader";
import EarlyAccessCategoryHeader from "../EarlyAccessCategoryHeader";
import FeaturedCategoryHeader from "../FeaturedCategoryHeader";
import { getCountryCode } from "../../state/modules/config/selectors";

const CategoryHeaderContainer = ({ scrollFunction }) => {
  const isEarlyAccess = useSelector(getCategoryIsEarlyAccess);
  const category = useSelector(getCategoryDetails);
  const viewportCategory = useSelector(getViewportCategory);
  const isComingSoon = useSelector(getIsEarlyAccessCategoryComingSoon);
  const isFeaturedHeader = useSelector(getCategoryDetailsFeaturedHeaderEnabled);
  const featuredHeaderData = useSelector(getCategoryDetailsFeaturedHeaderData);
  const mediaType = featuredHeaderData?.web?.videoAssetId ? "video" : "image";
  const browseCountry = useSelector(getCountryCode);
  const { primarySeoLinks } = useSelector(getCategorySeoLinks);
  const visualCategories = useSelector(getCategoryVisualCategories);
  const hasVisualCategories = visualCategories.length > 0;
  const hasHeaderLinks = !!primarySeoLinks.length && !hasVisualCategories;

  const renderEarlyAccessHeader = () => (
    <EarlyAccessCategoryHeader
      hasHeaderLinks={hasHeaderLinks}
      category={category}
      viewportCategory={viewportCategory}
      isComingSoon={isComingSoon}
    />
  );

  const renderFeaturedHeader = () => (
    <FeaturedCategoryHeader
      hasHeaderLinks={hasHeaderLinks}
      hasVisualCategories={hasVisualCategories}
      category={category}
      mediaType={mediaType}
      viewportCategory={viewportCategory}
      scrollFunction={scrollFunction}
      featuredHeaderData={featuredHeaderData}
    />
  );

  const renderDefaultHeader = () => (
    <CategoryHeader
      hasHeaderLinks={hasHeaderLinks}
      hasVisualCategories={hasVisualCategories}
      category={category}
      browseCountry={browseCountry}
    />
  );

  if (isEarlyAccess) {
    return renderEarlyAccessHeader();
  } else if (isFeaturedHeader) {
    return renderFeaturedHeader();
  } else {
    return renderDefaultHeader();
  }
};

CategoryHeaderContainer.propTypes = {
  scrollFunction: PropTypes.func.isRequired
};

export default CategoryHeaderContainer;
